import FileUpload from '../../components/file-upload';
import {Collapse} from 'bootstrap';
import GeneralUtility from '../../utilities/general-utility';
import PluginAction from '../plugin-action';

/**
 * Basic create action for managing offers. Can be used as a base for creat actions of specific offers.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default abstract class AbstractCreateAction extends PluginAction {
    /**
     * The main form of the action.
     */
    protected form: HTMLFormElement;

    /**
     * Whether this is a template or an actual offer.
     */
    protected isTemplate: boolean = false;

    protected constructor(container: HTMLElement) {
        super(container);
        const form = container.querySelector<HTMLFormElement>('form#offer');
        if (!form) {
            throw new Error('Required elements missing.');
        }
        this.form = form;
        this.isTemplate = this.form.dataset.isTemplate !== undefined && this.form.dataset.isTemplate === '1';

        this.initializeSideOffers();
        this.initalizeFileUpload();
        this.initializeInsertVendorDataIntoContactData();
    }

    /**
     * Initializes the side offer collapsibles.
     */
    private initializeSideOffers(): void {
        this.container.querySelectorAll<HTMLElement>('[id^="sideOfferCollapse"]').forEach(collapsible => {
            const checkbox = this.container.querySelector<HTMLInputElement>('[data-bs-target="#' + collapsible.getAttribute('id') + '"]');
            if (checkbox && checkbox.checked) {
                const collapse = Collapse.getOrCreateInstance(collapsible);
                collapse.show();
            }
        });
    }

    /**
     * Initializes the file upload.
     */
    private initalizeFileUpload(): void {
        const fileField = this.container.querySelector<HTMLInputElement>('#files');
        const hiddenField = this.container.querySelector<HTMLInputElement>('#files-hidden');
        if (fileField && hiddenField) {
            new FileUpload(fileField, hiddenField);
        }
    }

    /**
     * Initializes the procedure, to insert data of a vendor into the contact fields of an offer on demand.
     */
    private initializeInsertVendorDataIntoContactData(): void {
        const button = this.container.querySelector<HTMLElement>('#insertVendorData');
        if (!button || !button.dataset.uid) {
            return;
        }

        // For admins, the user UID is provided by select-field at the top
        let uid: number | null = null;
        const vendorSelect = this.container.querySelector<HTMLInputElement>('select#vendor');
        if (vendorSelect) {
            uid = parseInt(vendorSelect.value);
            vendorSelect.addEventListener('change', () => {
                uid = parseInt(vendorSelect.value);
            });
        }
        // Otherwise use the user UID that is attached to the offer (or the UID of the current user for new offers)
        else {
            uid = parseInt(button.dataset.uid);
        }

        button.addEventListener('click', () => {
            fetch(GeneralUtility.getUrl() + '?manage-offer-api[endpoint][]=vendorDataForContactData&uid=' + uid)
                .then((response: Response) => {
                    if (response.status !== 200) {
                        throw new Error(response.status + ' ' + response.statusText);
                    }
                    return response.json();
                })
                .then((data: { [key: string]: string }) => {
                    for (const name in data) {
                        const field = this.container.querySelector<HTMLInputElement>('#' + name);
                        if (field) {
                            field.value = data[name];
                        }
                    }
                })
                .catch(reason => {
                    throw new Error('An error occurred while loading vendor data: ' + reason);
                });
        });
    }
}
